/* eslint-disable import/prefer-default-export */
import i18n from "@/i18n";

export const DiagnosticVisualizationMode = {
	AllRecords:  1,
	WorstRecord: 2,
};

// Região em que se encontra o eixo para diagnósticos.
export const ShaftType =
{
	Generator: 0,
	HSS:       1,
	IMS:       2,
	LSS:       3,
};

export const DiagnosticLoosenessLocationEnum = {
	HSS: i18n.t("Labels.GearboxRegions.HSS"),
	LSS: i18n.t("Labels.GearboxRegions.LSS"),
	IMS: i18n.t("Labels.GearboxRegions.IMS"),
	GEN: i18n.t("Labels.GearboxRegions.GEN"),
};

// Posição do sensor no WEB
export const SensorPosition =
{
	// Posição Desconhecido.
	Unknow: {
		PositionClass: "",
		PositionId:    0,
	},

	// Gerador na parte traseira.
	GT: {
		PositionClass: "VGDW",
		PositionId:    1,
	},

	// Gerador na parte dianteira.
	GD: {
		PositionClass: "VGUW",
		PositionId:    2,
	},

	// Eixo alta velocidade Radial.
	HSSR: {
		PositionClass: "VHSS-R",
		PositionId:    3,
	},

	// Eixo alta velocidade Axial.
	HSSA: {
		PositionClass: "VHSS-A",
		PositionId:    4,
	},

	// Eixo intermediário
	IMS: {
		PositionClass: "VIMS",
		PositionId:    5,
	},

	// Eixo de baixa velocidade.
	LSS: {
		PositionClass: "VLSS",
		PositionId:    6,
	},

	// Planetaria horizontal (0°)
	HP: {
		PositionClass: "VP-0",
		PositionId:    7,
	},

	// Planetria vertical (90°)
	VP: {
		PositionClass: "VP-90",
		PositionId:    8,
	},

	// Mancal principal radial
	MBR: {
		PositionClass: "VMP-R",
		PositionId:    9,
	},

	// Mancal principal axial
	MBA: {
		PositionClass: "VMP-A",
		PositionId:    10,
	},

	// Microfone posição A
	MICA: {
		PositionClass: "MIC",
		PositionId:    11,
	},

	// Microfone posição B
	MICB: {
		PositionClass: "",
		PositionId:    12,
	},

	// Referência de fase.
	PR: {
		PositionClass: "REF",
		PositionId:    13,
	},

	// Mancal Pitch Radial 1.
	PBR1: {
		PositionClass: "AMP1",
		PositionId:    14,
	},

	// Mancal Pitch Radial 2.
	PBR2: {
		PositionClass: "AMP2",
		PositionId:    15,
	},

	// Mancal Pitch Radial 3.
	PBR3: {
		PositionClass: "AMP3",
		PositionId:    16,
	},

	// Modbus.
	ModBus: {
		PositionClass: "modbus",
		PositionId:    17,
	},

	// Voltímetro
	Vin: {
		PositionClass: "VIN",
		PositionId:    18,
	},

	// Sensor de Óleo.
	OilWear: {
		PositionClass: "OIL",
		PositionId:    19,
	},

	// Mancal Principal DownWind Radial.
	MBDWR: {
		PositionClass: "MBDWR",
		PositionId:    20,
	},

	// / Mancal Principal UpWind Radial.
	MBUWR: {
		PositionClass: "MBUWR",
		PositionId:    21,
	},

	// / Mancal Principal UpWind Axial.
	MBUWA: {
		PositionClass: "MBUWA",
		PositionId:    22,
	},
};

/**
 * Enumeração dos tipos de sinais de óleo.
 */
export const OilSignalType = {
	Undefined:      0,
	Micro4:         1,
	Micro6:         2,
	Micro14:        3,
	Micro21:        4,
	Micro38:        5,
	Micro70:        6,
	Air:            7,
	Cutting:        8,
	Fatigue:        9,
	Fiber:          10,
	Sliding:        11,
	Unknown:        12,
	OilDegradation: 13,
	TotalBubbles:   14,
	TotalParticles: 15,
	Temp:           16,
};

/**
 * Enumeração dos tipos de modo de falha.
 */
export const DiagnosticFailMode = {
	MainShaftUnbalance:                 0,
	MainShaftAngularMisalignment:       1,
	MainShaftParallelMisalignment:      2,
	UnbalanceGeneratorShaft:            3,
	ElectricFailureGenerator:           4,
	RollingBearingsFailure:             10,
	GeneratorShaftParallelMisalignment: 11,
	GearsStageTwo:                      12,
	GearsStageThree:                    13,
	Looseness:                          14,
	Planetary:                          15,
};

/**
 * Unidades em tendências de componente de frequência (x).
 */
export const MeasureUnitsX = {
	order: 0,
	hertz: 1
};

/**
 * Unidades em tendências de componente de frequência (y).
 */
export const MeasureUnitsY = {
	mms: 0,
	g:   1
};
